// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"79f44312","103":"9898448e","255":"013cd2b1","342":"cac94cbc","925":"f9a8d9f2"}[chunkId] + ".chunk.css";
};